import Vue from 'vue'
import Router from 'vue-router'
import Welcome from '@/components/Welcome'
import DailyReport from '@/components/DailyReport'
import WeeklyReport from '@/components/WeeklyReport'
import Compset from '@/components/Compset'

Vue.use(Router)

export default new Router({
  routes: [
    { name: 'Welcome', path: '/', component: Welcome, meta: { title: 'Welcome' } },
    { name: 'Create', path: '/welcome/:action', component: Welcome, meta: { title: 'Welcome' }, props: true },
    // DailyReport & WeeklyReport  is needed for GENERATE  reports
    { name: 'DailyReport', path: '/DailyReport/:action', component: DailyReport, meta: { title: 'DailyReport' }, props: true },
    { name: 'WeeklyReport', path: '/WeeklyReport/:action', component: WeeklyReport, meta: { title: 'WeeklyReport' }, props: true },
    // Compset is needed to add Service category for tasks from create task. This is needed for the communities does not have helpdesk menus
    { name: 'Compset', path: '/Compset', component: Compset, meta: { title: 'Settings' }, props: true }
    // remaining routers are added dynamically in App.vue while creating menu
  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js